import { Route, Routes } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { I18nBootstrap } from './i18n/I18nBootstrap';
import { Layout } from './components/layout';
import { HomePage } from './pages/home';
import { ProductPage } from './pages/product';
import { GetStartedPage } from './pages/get-started';
import { FaqPage } from './pages/faq';
import { ContactPage } from './pages/contact';
import { NotFoundPage } from './pages/not-found';
import { DocArticlePage, DocsIndexPage } from './pages/docs';
import { LegalPageView } from './pages/legal';
import { legalSlugs } from '@shared/content-schemas';

/**
 * The route tree. Every page here must also be in routes.ts (the prerender
 * list); tests/unit/prerender-render.test.ts renders each listed route and
 * fails if one falls through to the 404.
 */
export function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <I18nBootstrap>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="product" element={<ProductPage />} />
            <Route path="get-started" element={<GetStartedPage />} />
            <Route path="faq" element={<FaqPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="docs" element={<DocsIndexPage />} />
            <Route path="docs/:slug" element={<DocArticlePage />} />
            {legalSlugs.map((slug) => (
              <Route key={slug} path={slug} element={<LegalPageView slug={slug} />} />
            ))}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </I18nBootstrap>
    </I18nextProvider>
  );
}
